import styled from "styled-components";

export const InvalidJobsTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const InvalidJobsTitleIcon = styled.span`
  display: inline-flex;
  color: ${({ theme }) => theme.colors.warningBorder};
  font-size: 20px;
`;

export const InvalidJobsMessage = styled.p`
  margin: 0 0 12px;
  color: ${({ theme }) => theme.colors.dark};
`;

export const InvalidJobsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 8px;
`;

export const InvalidJobItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;

  & + & {
    border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
  }
`;

export const InvalidJobName = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const InvalidJobReq = styled.span`
  margin-left: 6px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gray};
`;

export const InvalidJobIssues = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  .ant-tag {
    margin-inline-end: 0;
    color: ${({ theme }) => theme.colors.warningMessage};
    background: ${({ theme }) => theme.colors.warningBg};
    border-color: ${({ theme }) => theme.colors.warningBorder};
  }
`;

export const InvalidJobsFooter = styled.p`
  margin: 12px 0 0;
  color: ${({ theme }) => theme.colors.gray};
`;
